import { FilterByBlockReason } from "../../../../components/Filters/FilterByBlockReason";
import { TableSearch } from "../../../../components/TableSearch";

const Filters = () => {
  return (
    <div className="custom-header-wrapper">
      <div className="align-items-center position-relative">
        <TableSearch
          label={
            <>
              <strong>Search</strong> all cache items
            </>
          }
          placeholder="Type to filter..."
        />
      </div>

      <div className="filters-wrapper position-relative">
        <FilterByBlockReason />
      </div>
    </div>
  );
};

export { Filters };
